export const ModalMainContainer = {
  padding: '80px 125px',
  textAlign: 'center'
};
